import jsPDF from "jspdf";
import { logoBase64 } from "./LogoBin";

interface ImageData {
    width: number;
    height: number;
    base64string: string;
}

async function getImageData(imageUrl): Promise<ImageData> {
    try {
        const response = await fetch(imageUrl);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        return new Promise((resolve, reject) => {
            // Create a new Image object to get dimensions
            const img = new Image();

            // Read the blob as a Base64 string using FileReader
            const reader = new FileReader();
            reader.readAsDataURL(blob);

            img.onload = () => {
                // Once both operations are complete, resolve the promise with the data object
                if (reader.result) {
                    const result: ImageData = {
                        width: img.naturalWidth,
                        height: img.naturalHeight,
                        base64string: reader.result.toString(),
                    };
                    resolve(result);
                } else {
                    reject(new Error("Could not read image as Base64."));
                }
                URL.revokeObjectURL(blobUrl); // Clean up the temporary URL
            };

            img.onerror = () => {
                URL.revokeObjectURL(blobUrl);
                reject(new Error("Failed to load image for dimensions."));
            };

            img.src = blobUrl; // Set the source to the Blob URL to trigger loading
        });
    } catch (error) {
        console.error("Error in getImageData:", error);
        return null;
    }
}

export interface PdfDocLine {
    type: "h1" | "h2" | "paragraph" | "field-value";
    content: string;
    orderInd: number;
}

export async function pdfCreate(lines: PdfDocLine[], headerLogoUrl: string = null): Promise<Blob> {

    var pageInnerHeight = 280
    var pageYPos = 10
    var pageIndex = 2
    var pageInnerWidth = 150
    // default font settings (paragraph)
    var lineHeight = 5
    var marginLeft = 20
    var fontColor = "#000000"
    var fontSize = 10
    var fontStyle = "normal"
    var fontName = "Helvetica"
    var spacing = 3
    // h1 font settings
    var h1FontSize = 22
    var h1Spacing = 12
    var h1LineHeight = 11
    // h2 font settings
    var h2FontSize = 14
    var h2Spacing = 8
    var h2LineHeight = 7

    const doc = new jsPDF({ compress: true })
    doc.setFontSize(fontSize)
    doc.setTextColor(fontColor)
    doc.setFont(fontName, fontStyle)

    // Fall back to no logo if Advisor's logo cannot be downloaded.
    var logoBin = null // logoBase64
    var logoWidth = 36
    var logoHeight = 9
    if (headerLogoUrl) {
        console.log("Getting header logo for pdf: ", headerLogoUrl)
        await getImageData(headerLogoUrl).then((headerLogoData) => {
            console.log(headerLogoData)
            if (headerLogoData) {
                logoBin = headerLogoData.base64string
                var asp = headerLogoData.width / headerLogoData.height
                logoWidth = logoHeight * asp
            }
        }).catch((e) => {
            console.log("Failed to get logo from header: ", e)
        })
    }

    if (logoBin !== null) {
        doc.addImage(logoBin, 'PNG', 20, 15, logoWidth, logoHeight, null)
        doc.setTextColor("#555555")
        doc.text("Questionnaire review", 20, 29)
        doc.setTextColor(fontColor)
        pageYPos += 16
    }

    lines = lines.sort((a, b) => a.orderInd - b.orderInd)

    lines.forEach((lineObject, i) => {

        if (lineObject.type === "h1") {
            pageYPos += h1Spacing
            lineHeight = h1LineHeight
            doc.setFontSize(h1FontSize);
            doc.setFont(fontName, "bold");
        } else if (lineObject.type === "h2") {
            pageYPos += h2Spacing
            lineHeight = h2LineHeight
            doc.setFontSize(h2FontSize);
            doc.setFont(fontName, "bold");
        } else {
            pageYPos += spacing
        }

        if (lineObject.type === "field-value") {
            doc.setTextColor("#555555")
            marginLeft = 25
        }

        const splitLabelText = doc.splitTextToSize(lineObject.content, pageInnerWidth);

        splitLabelText.forEach(lineText => {

            pageYPos += lineHeight

            // New page
            if (pageYPos > pageInnerHeight) {
                doc.insertPage(pageIndex)
                pageIndex += 1
                pageYPos = 20
                // doc.addImage(logoBase64, 'PNG', 168, 6, 36, 9);
            }

            doc.text(`${lineText}`, marginLeft, pageYPos)
        })

        // Reset settings
        marginLeft = 20
        lineHeight = 5
        doc.setFontSize(fontSize)
        doc.setTextColor(fontColor)
        doc.setFont(fontName, fontStyle)
    })

    // doc.save("test.pdf");
    return doc.output('blob')
}